import { FEATURES, TONES } from '../HomeFeatures';

const MEDIA = '/videos/desktop';

export const DESK_TONES = {
  ...TONES,
  teal: { color: '#0d9488', tint: '#f0fdfa', deep: '#115e59' },
};

const CLIP = (name) => ({ mp4: `${MEDIA}/${name}.mp4`, webm: `${MEDIA}/${name}.webm`, poster: `${MEDIA}/${name}.jpg` });

// One headline number per feature; only claims already made elsewhere on the site or visible in the app.
const STATS = {
  racecard: { value: 4, label: 'highlight checks on every runner' },
  form: { value: 4, label: 'performance splits: career, distance, class and course' },
  stats: { value: 22, label: 'analysis tables for every race' },
  rating: { value: 10000, label: 'simulations behind every rating' },
  pnl: null,
};

export const PNL_FEATURE = {
  id: 'pnl',
  tone: 'teal',
  short: 'P&L Tracker',
  eyebrow: 'Profit & Loss Tracker',
  title: 'Track every selection. See what’s really working.',
  copy: 'Drag runners from the racecard into a strategy, choose Win or Each Way at SP or your own odds, and HorseStat settles every result into a running profit and loss.',
};

const CLIP_NAMES = { form: 'form-performance' };

export const DESK_FEATURES = [...FEATURES, PNL_FEATURE].map((feature) => ({
  ...feature,
  stat: STATS[feature.id],
  clip: CLIP(CLIP_NAMES[feature.id] || feature.id),
}));

export const TABLE_STILLS = [
  { key: 'form', label: 'Form' },
  { key: 'performance', label: 'Performance' },
  { key: 'going', label: 'Going' },
  { key: 'pace', label: 'Pace map' },
  { key: 'trainer', label: 'Trainer' },
  { key: 'jockey', label: 'Jockey' },
  { key: 'owner', label: 'Owner' },
  { key: 'sire', label: 'Sire' },
  { key: 'dam', label: 'Dam' },
].map((still) => ({ ...still, src: `${MEDIA}/table-${still.key}.jpg` }));

const SILK = (horse) => `/images/silks/${horse.toLowerCase().replace(/[^a-z]+/g, '-')}.png`;

// The real "Demo" strategy in the app (1 Oct 2026, £10 default stake): £70.00 outlay, £108.25 returns, +£38.25.
export const PNL_STRATEGY = {
  name: 'Demo',
  stake: 10,
  picks: [
    { horse: 'Somerton', course: 'Salisbury', time: '13:30', type: 'win', oddsSource: 'SP', odds: '3/1', pos: 4 },
    { horse: 'Gold Army', course: 'Salisbury', time: '14:04', type: 'ew', oddsSource: 'SP', odds: '7/4', pos: 2, placesPaid: 3 },
    { horse: 'Kamaal', course: 'Salisbury', time: '14:39', type: 'win', oddsSource: 'SP', odds: '11/4', pos: 1 },
    { horse: 'Regional Rock', course: 'Salisbury', time: '15:49', type: 'win', oddsSource: 'SP', odds: '9/2', pos: 1 },
    { horse: 'Celestias Comet', course: 'Nottingham', time: '16:18', type: 'ew', oddsSource: 'SP', odds: '4/1', pos: 2, placesPaid: 3 },
    { horse: 'Dancing Tiger', course: 'Salisbury', time: '16:24', type: 'ew', oddsSource: 'SP', odds: '6/1', pos: 8, placesPaid: 3 },
    { horse: 'Melissa Honey', course: 'Nottingham', time: '16:50', type: 'win', oddsSource: 'SP', odds: '6/1', pos: 9 },
  ].map((pick) => ({ ...pick, silk: SILK(pick.horse) })),
};
